import { ElevesViewField } from '@teetsh/app/src/types/eleves';
import { VisibilityState } from '@tanstack/react-table';

export function viewFieldsToVisibilityState(
  viewField: ElevesViewField[],
): VisibilityState {
  return viewField.reduce((acc, field) => {
    acc[field.id] = field.visible;
    return { ...acc, [field.id]: field.visible };
  }, {});
}
